import { FC, ReactNode } from 'react';

import { defineMessages, useIntl } from 'dibs-react-intl';
import { SingleSelect } from 'dibs-elements/exports/SingleSelect';

import { PRIMARY_INTEREST, FormData } from '../reducer';

type PrimaryInterestField = typeof PRIMARY_INTEREST;
type PrimaryInterestValue = FormData[PrimaryInterestField];

import styles from './styles/IFramedPromoPartnershipPCForm.scss';

const messages = defineMessages({
    furniture: {
        id: 'iFramedpromoPartnership.PrimaryInterestSelect.furniture',
        defaultMessage: 'Furniture',
    },
    fashion: {
        id: 'iFramedpromoPartnership.PrimaryInterestSelect.fashion',
        defaultMessage: 'Fashion',
    },
    fineArt: {
        id: 'iFramedpromoPartnership.PrimaryInterestSelect.fineArt',
        defaultMessage: 'Fine Art',
    },
    jewelry: {
        id: 'iFramedpromoPartnership.PrimaryInterestSelect.jewelry',
        defaultMessage: 'Jewelry',
    },
    other: {
        id: 'iFramedpromoPartnership.PrimaryInterestSelect.other',
        defaultMessage: 'Other',
    },
    placeholder: {
        id: 'iFramedpromoPartnership.PrimaryInterestSelect.placeholder',
        defaultMessage: 'What is your primary interest?',
    },
});

type Props = {
    value: PrimaryInterestValue;
    errorMessage: ReactNode;
    disabled?: boolean;
    setField: (field: PrimaryInterestField, value: PrimaryInterestValue) => void;
};

const PrimaryInterestSelect: FC<Props> = ({ value, errorMessage, disabled, setField }) => {
    const { formatMessage } = useIntl();

    const selectOptions = [
        {
            value: 'Furniture',
            label: formatMessage(messages.furniture),
        },
        {
            value: 'Fashion',
            label: formatMessage(messages.fashion),
        },
        {
            value: 'Fine Art',
            label: formatMessage(messages.fineArt),
        },
        {
            value: 'Jewelry',
            label: formatMessage(messages.jewelry),
        },
        {
            value: 'Other',
            label: formatMessage(messages.other),
        },
    ];

    return (
        <div className={styles.field}>
            <SingleSelect
                dataTn="promo-partnership-primary-interest-single-select"
                name="promo-partnership-primary-interest"
                placeholder={formatMessage(messages.placeholder)}
                hasAnimatedPlaceholder
                value={value}
                onChange={option => setField(PRIMARY_INTEREST, option?.value || '')}
                options={selectOptions}
                disabled={disabled}
                errorMessage={errorMessage}
                hasError={!!errorMessage}
            />
        </div>
    );
};

export default PrimaryInterestSelect;
